import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  AuthService,
  ClientService,
  IClient,
  IUserDto,
  ToastService,
} from 'src/app/core';
import { MustMatch } from 'src/app/core/validators/compare.validator';

@Component({
  selector: 'ic-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
})
export class SignUpComponent implements OnInit {
  public registrationForm: FormGroup;
  public formErrors: any = {};
  public clientConfig: IClient;
  constructor(
    private readonly fb: FormBuilder,
    private readonly clientService: ClientService,
    private readonly authService: AuthService,
    private readonly toastService: ToastService,
    public readonly activeDialog: NgbActiveModal
  ) {
    this.clientConfig = this.clientService.currentClientValue;
  }

  ngOnInit(): void {
    this.registrationForm = this.fb.group(
      {
        name: ['', [Validators.required, Validators.maxLength(50)]],
        email: [
          '',
          [Validators.required, Validators.maxLength(50), Validators.email],
        ],
        mobile: [
          '',
          [
            Validators.required,
            Validators.minLength(14),
            Validators.maxLength(14),
            Validators.pattern(/^\((?![01])\d{3}\) \d{3}-\d{4}$/),
          ],
        ],
        password: ['', [Validators.required, Validators.maxLength(30)]],
        confirmPassword: ['', [Validators.required, Validators.maxLength(30)]],
      },
      {
        validator: MustMatch('password', 'confirmPassword'),
      }
    );

    Object.keys(this.registrationForm.controls).forEach((key) => {
      this.registrationForm.get(key).markAsTouched();
    });

    this.registrationForm.valueChanges.subscribe((changes) => {
      Object.keys(changes).forEach((controlName) => {
        const control = this.registrationForm.controls[controlName];
        this.formErrors[controlName] =
          (control.touched || control.dirty) && control.errors ? 'error' : null;
      });
    });
  }

  get fc() {
    return this.registrationForm.controls;
  }

  isNumber(evt: any) {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
    return true;
  }

  signUp() {
    const model: IUserDto = {
      ...this.registrationForm.value,
    };
    model.restaurantId = this.clientConfig?.restaurantId;
    model.mobile = model.mobile.replace(/\D/g, '');
    model.isMobileVerified = false;
    this.authService.register(model).subscribe(
      (result) => {
        if (result.isSuccess) {
          this.toastService.showSuccess(
            'Registration done successfully! Email verification sent'
          );
          this.activeDialog.close();
        } else {
          this.toastService.showError(result.errors[0]);
        }
      },
      (err) => {
        this.toastService.showError('Server Error! Please try after sometime');
      }
    );
  }

  trimEmail() {
    const val = this.registrationForm.get('email').value.trim();
    this.registrationForm.get('email').setValue(val);
  }
}
